import { db } from "@/firebase/init.js";
import {
  collection,
  // Get All
  query,
  orderBy,
  getDocs,
  // Add one
  setDoc,
  doc,
  // Get One
  getDoc,
  // Update one
  updateDoc,
  // Delete one
  deleteDoc,
} from "firebase/firestore";

const offerModule = {
  namespaced: true,
  state: {
    offersList: [],
    offerUpdate: {},
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getOffers: (state) => state.offersList,
    getUpdateOffer: (state) => state.offerUpdate,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All offers
    setOffers: (state, payload) => {
      state.offersList = payload;
    },

    // Add
    addOffer: (state, payload) => {
      if (state.offersList.length > 0) state.offersList.unshift(payload);
      else state.offersList = [payload];
    },

    // Get by Id
    getOfferById: (state, payload) => {
      state.offerUpdate = payload;
    },

    // Update
    updateOffer: (state, payload) => {
      const findIndex = state.offersList.findIndex(
        (offer) => offer.offer_id == payload.offer_id
      );
      state.offersList[findIndex] = payload;
    },

    // Delete
    deleteOffer: (state, payload) => {
      let filtered = state.offersList.filter((offer) => {
        return offer.offer_id != payload;
      });
      state.offersList = filtered;
    },
  },
  actions: {
    // Get All Offers
    async fetchOffers({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const offersList = await getDocs(
        query(collection(db, "Offers"), orderBy("created_date", "desc"))
      );
      let offerArray = [];
      if (!offersList.empty) {
        offersList.forEach((doc) => {
          offerArray.push({ ...doc.data(), offer_id: doc.id });
        });
      } else {
        console.log("No Offers found");
        offerArray = false;
      }
      commit("setOffers", offerArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return offersList;
    },
    // Add Offer
    async addOffer({ commit }, payload) {
      const documentReference = doc(collection(db, "Offers"));
      const offer = {
        ...payload,
        offer_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, offer);
      commit("addOffer", offer);
    },

    // Get By Id
    async getOfferById({ commit }, payload) {
      let offer = await getDoc(doc(db, "Offers", payload));
      commit("getOfferById", offer.data());
      return offer.data();
    },

    // Update Offer
    async updateOffer({ commit }, payload) {
      updateDoc(doc(db, "Offers", payload.offer_id), payload);
      commit("updateOffer", payload);
    },
    // Delete Offer
    async deleteOffer({ commit }, payload) {
      deleteDoc(doc(db, "Offers", payload));
      commit("deleteOffer", payload);
    },
  },
};

export default offerModule;
